// USC's undergraduate majors (#2596, founder 2026-09-30: "majors offered by the
// college in the public page"). Read on 2026-09-30 from the official USC Catalogue
// 2026-2027, Programs by School (catalogue.usc.edu, navoid 9453): every program
// under a school's "Bachelor's Degree" heading, plus Dornsife's "Combined Major"
// heading, in the Catalogue's school order. Left out: the Catalogue's
// "..., X Emphasis", "..., Health Science Track" and "..., Honors Programs" lines,
// which are emphases inside a listed major; minors, certificates, intensives,
// dual and graduate degrees. Named programs in parentheses, such as Business
// Administration (Finance), are separate majors in the Catalogue and are kept.
// The Catalogue's asterisk (programs under Dornsife's jurisdiction) is dropped.
// Flags quote the school admission pages in the college file (`cinema`,
// `thornton`, `kaufman`, `roski`) and the First-Year Students page
// (`firstYear`) for Dramatic Arts, Iovine and Young, Architecture and Marshall's
// World Bachelor in Business. The KB's majors list was the starting point; the
// Catalogue wins.
const majors = {
    "slug": "university-of-southern-california",
    "read": "2026-09-30",
    "intro": "Every bachelor's major in USC's official 2026-2027 Catalogue, grouped by the school that offers it, with the degree it leads to. Emphases, minors and graduate programs are left out.",
    "groups": [
        {
            "name": "USC Iovine and Young Academy",
            "source": {
                "label": "USC Catalogue 2026-2027, Programs by School",
                "url": "https://catalogue.usc.edu/content.php?catoid=22&navoid=9453"
            },
            "majors": [
                {
                    "name": "Arts, Technology and the Business of Innovation",
                    "degree": "BS",
                    "flag": "Supplementary forms and the school's own departmental requirements, by its deadline.",
                    "flagSource": "firstYear"
                },
                {
                    "name": "Business of Innovation",
                    "degree": "BS",
                    "flag": "Supplementary forms and the school's own departmental requirements, by its deadline.",
                    "flagSource": "firstYear"
                },
                {
                    "name": "Human Technology Interaction",
                    "degree": "BS",
                    "flag": "Supplementary forms and the school's own departmental requirements, by its deadline.",
                    "flagSource": "firstYear"
                }
            ]
        },
        {
            "name": "USC Leventhal School of Accounting",
            "source": {
                "label": "USC Catalogue 2026-2027, Programs by School",
                "url": "https://catalogue.usc.edu/content.php?catoid=22&navoid=9453"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "USC School of Architecture",
            "source": {
                "label": "USC Catalogue 2026-2027, Programs by School",
                "url": "https://catalogue.usc.edu/content.php?catoid=22&navoid=9453"
            },
            "majors": [
                {
                    "name": "Architectural Studies",
                    "degree": "BS",
                    "flag": "Supplementary forms and the school's own departmental requirements, by its deadline.",
                    "flagSource": "firstYear"
                },
                {
                    "name": "Architecture",
                    "degree": "BArch",
                    "flag": "Supplementary forms and the school's own departmental requirements, by its deadline.",
                    "flagSource": "firstYear"
                },
                {
                    "name": "Architecture and Inventive Technologies",
                    "degree": "BS",
                    "flag": "Supplementary forms and the school's own departmental requirements, by its deadline.",
                    "flagSource": "firstYear"
                }
            ]
        },
        {
            "name": "USC Roski School of Art and Design",
            "source": {
                "label": "USC Catalogue 2026-2027, Programs by School",
                "url": "https://catalogue.usc.edu/content.php?catoid=22&navoid=9453"
            },
            "majors": [
                {
                    "name": "Art",
                    "degree": "BA",
                    "flag": "A portfolio, an artist statement and a list of creative accomplishments, with your USC application.",
                    "flagSource": "roski"
                },
                {
                    "name": "Design",
                    "degree": "BFA",
                    "flag": "A portfolio, an artist statement and a list of creative accomplishments, with your USC application.",
                    "flagSource": "roski"
                },
                {
                    "name": "Fine Arts",
                    "degree": "BFA",
                    "flag": "A portfolio, an artist statement and a list of creative accomplishments, with your USC application.",
                    "flagSource": "roski"
                }
            ]
        },
        {
            "name": "USC Marshall School of Business",
            "source": {
                "label": "USC Catalogue 2026-2027, Programs by School",
                "url": "https://catalogue.usc.edu/content.php?catoid=22&navoid=9453"
            },
            "majors": [
                {
                    "name": "Accounting and Finance",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence for Business",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration (Business Analytics)",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration (Cinematic Arts)",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration (Communication)",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration (Entrepreneurship and Innovation)",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration (Finance)",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration (International Relations)",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration (Leadership and Innovation)",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration (Marketing)",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration (Real Estate Finance)",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration (Risk Management)",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration (World Program)",
                    "degree": "BS",
                    "flag": "The World Bachelor in Business has its own requirements: supplementary forms and the school's own departmental requirements, by its deadline.",
                    "flagSource": "firstYear"
                },
                {
                    "name": "Business of Cinematic Arts",
                    "degree": "BS"
                },
                {
                    "name": "Real Estate Finance and Development",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "USC School of Cinematic Arts",
            "source": {
                "label": "USC Catalogue 2026-2027, Programs by School",
                "url": "https://catalogue.usc.edu/content.php?catoid=22&navoid=9453"
            },
            "majors": [
                {
                    "name": "Animation and Digital Arts",
                    "degree": "BFA",
                    "flag": "A SlideRoom application with supplemental materials for each program you apply to.",
                    "flagSource": "cinema"
                },
                {
                    "name": "Cinema and Media Studies",
                    "degree": "BA",
                    "flag": "A SlideRoom application with supplemental materials for each program you apply to.",
                    "flagSource": "cinema"
                },
                {
                    "name": "Cinematic Arts, Film and Television Production",
                    "degree": "BA",
                    "flag": "A SlideRoom application with supplemental materials for each program you apply to.",
                    "flagSource": "cinema"
                },
                {
                    "name": "Cinematic Arts, Film and Television Production",
                    "degree": "BFA",
                    "flag": "A SlideRoom application with supplemental materials for each program you apply to.",
                    "flagSource": "cinema"
                },
                {
                    "name": "Game Art",
                    "degree": "BFA",
                    "flag": "A SlideRoom application with supplemental materials for each program you apply to.",
                    "flagSource": "cinema"
                },
                {
                    "name": "Game Development and Interactive Design",
                    "degree": "BFA",
                    "flag": "A SlideRoom application with supplemental materials for each program you apply to.",
                    "flagSource": "cinema"
                },
                {
                    "name": "Media Arts and Practice",
                    "degree": "BA",
                    "flag": "A SlideRoom application with supplemental materials for each program you apply to.",
                    "flagSource": "cinema"
                },
                {
                    "name": "Themed Entertainment",
                    "degree": "BFA",
                    "flag": "A SlideRoom application with supplemental materials for each program you apply to.",
                    "flagSource": "cinema"
                },
                {
                    "name": "Writing for Screen and Television",
                    "degree": "BFA",
                    "flag": "A SlideRoom application with supplemental materials for each program you apply to.",
                    "flagSource": "cinema"
                }
            ]
        },
        {
            "name": "USC Dornsife College of Letters, Arts and Sciences",
            "source": {
                "label": "USC Catalogue 2026-2027, Programs by School",
                "url": "https://catalogue.usc.edu/content.php?catoid=22&navoid=9453"
            },
            "majors": [
                {
                    "name": "American Popular Culture",
                    "degree": "BA"
                },
                {
                    "name": "American Studies and Ethnicity (African American Studies)",
                    "degree": "BA"
                },
                {
                    "name": "American Studies and Ethnicity (Asian American Studies)",
                    "degree": "BA"
                },
                {
                    "name": "American Studies and Ethnicity",
                    "degree": "BA"
                },
                {
                    "name": "American Studies and Ethnicity (Chicano/Latino Studies)",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology (Visual Anthropology)",
                    "degree": "BA"
                },
                {
                    "name": "Applied and Computational Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Applied and Computational Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Archaeology and Heritage Studies",
                    "degree": "BA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Astronomy",
                    "degree": "BA"
                },
                {
                    "name": "Astronomy",
                    "degree": "BS"
                },
                {
                    "name": "Behavioral Economics and Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Biological Sciences (Biotechnology)",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences (Ecology, Evolution and Environment)",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences (Marine Biology)",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences (Molecular, Cellular and Developmental Biology)",
                    "degree": "BS"
                },
                {
                    "name": "Biophysics",
                    "degree": "BS"
                },
                {
                    "name": "Central European Studies",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry (Chemical Biology)",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry (Chemical Nanoscience)",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry (Research)",
                    "degree": "BS"
                },
                {
                    "name": "Classics",
                    "degree": "BA"
                },
                {
                    "name": "Cognitive Science",
                    "degree": "BA"
                },
                {
                    "name": "Comparative Literature",
                    "degree": "BA"
                },
                {
                    "name": "Computational Linguistics",
                    "degree": "BS"
                },
                {
                    "name": "Computational Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Contemporary Latino and Latin American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Earth Sciences",
                    "degree": "BA"
                },
                {
                    "name": "East Asian Area Studies",
                    "degree": "BA"
                },
                {
                    "name": "East Asian Languages and Cultures",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics and Data Science",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Science and Health",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Science and Health",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Systems Science",
                    "degree": "BS"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "Gender and Sexuality Studies",
                    "degree": "BA"
                },
                {
                    "name": "Geodesign",
                    "degree": "BS"
                },
                {
                    "name": "Geological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Global Geodesign",
                    "degree": "BS"
                },
                {
                    "name": "Global Studies",
                    "degree": "BA"
                },
                {
                    "name": "Health and Human Sciences",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Human Biology",
                    "degree": "BA"
                },
                {
                    "name": "Human Biology",
                    "degree": "BS"
                },
                {
                    "name": "Human Security and Geospatial Intelligence",
                    "degree": "BS"
                },
                {
                    "name": "Intelligence and Cyber Operations",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BA"
                },
                {
                    "name": "International Relations",
                    "degree": "BA"
                },
                {
                    "name": "International Relations (Global Business)",
                    "degree": "BA"
                },
                {
                    "name": "International Relations and the Global Economy",
                    "degree": "BA"
                },
                {
                    "name": "Italian",
                    "degree": "BA"
                },
                {
                    "name": "Jewish Studies",
                    "degree": "BA"
                },
                {
                    "name": "Latin American and Iberian Cultures, Media and Politics",
                    "degree": "BA"
                },
                {
                    "name": "Law, History, and Culture",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Middle East Studies",
                    "degree": "BA"
                },
                {
                    "name": "Narrative Studies",
                    "degree": "BA"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BA"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Non-Governmental Organizations and Social Change",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy, Politics and Economics",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy, Politics and Law",
                    "degree": "BA"
                },
                {
                    "name": "Physical Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Physics/Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Political Economy",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Quantitative Biology",
                    "degree": "BS"
                },
                {
                    "name": "Religion",
                    "degree": "BA"
                },
                {
                    "name": "Russian",
                    "degree": "BA"
                },
                {
                    "name": "Social Sciences, with an Emphasis in Economics",
                    "degree": "BA"
                },
                {
                    "name": "Social Sciences, with an Emphasis in Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Economics/Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Linguistics and Cognitive Science",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics and East Asian Languages and Cultures",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics and Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics/Economics",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "USC Annenberg School for Communication and Journalism",
            "source": {
                "label": "USC Catalogue 2026-2027, Programs by School",
                "url": "https://catalogue.usc.edu/content.php?catoid=22&navoid=9453"
            },
            "majors": [
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Public Relations and Advertising",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "USC Kaufman School of Dance",
            "source": {
                "label": "USC Catalogue 2026-2027, Programs by School",
                "url": "https://catalogue.usc.edu/content.php?catoid=22&navoid=9453"
            },
            "majors": [
                {
                    "name": "Dance",
                    "degree": "BFA",
                    "flag": "Materials, including a Kaufman portfolio, by December 1, and a live audition in January.",
                    "flagSource": "kaufman"
                }
            ]
        },
        {
            "name": "USC School of Dramatic Arts",
            "source": {
                "label": "USC Catalogue 2026-2027, Programs by School",
                "url": "https://catalogue.usc.edu/content.php?catoid=22&navoid=9453"
            },
            "majors": [
                {
                    "name": "Acting, Stage and Screen",
                    "degree": "BFA",
                    "flag": "The School of Dramatic Arts sets its own requirements, with December 1 as the only deadline.",
                    "flagSource": "firstYear"
                },
                {
                    "name": "Dramatic Arts",
                    "degree": "BA",
                    "flag": "The School of Dramatic Arts sets its own requirements, with December 1 as the only deadline.",
                    "flagSource": "firstYear"
                },
                {
                    "name": "Musical Theatre",
                    "degree": "BFA",
                    "flag": "The School of Dramatic Arts sets its own requirements, with December 1 as the only deadline.",
                    "flagSource": "firstYear"
                },
                {
                    "name": "Sound Design",
                    "degree": "BFA",
                    "flag": "The School of Dramatic Arts sets its own requirements, with December 1 as the only deadline.",
                    "flagSource": "firstYear"
                },
                {
                    "name": "Stage Management",
                    "degree": "BFA",
                    "flag": "The School of Dramatic Arts sets its own requirements, with December 1 as the only deadline.",
                    "flagSource": "firstYear"
                },
                {
                    "name": "Technical Direction",
                    "degree": "BFA",
                    "flag": "The School of Dramatic Arts sets its own requirements, with December 1 as the only deadline.",
                    "flagSource": "firstYear"
                },
                {
                    "name": "Theatrical Design",
                    "degree": "BFA",
                    "flag": "The School of Dramatic Arts sets its own requirements, with December 1 as the only deadline.",
                    "flagSource": "firstYear"
                },
                {
                    "name": "Visual and Performing Arts Studies",
                    "degree": "BA",
                    "flag": "The School of Dramatic Arts sets its own requirements, with December 1 as the only deadline.",
                    "flagSource": "firstYear"
                }
            ]
        },
        {
            "name": "USC Viterbi School of Engineering",
            "source": {
                "label": "USC Catalogue 2026-2027, Programs by School",
                "url": "https://catalogue.usc.edu/content.php?catoid=22&navoid=9453"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence",
                    "degree": "BS"
                },
                {
                    "name": "Astronautical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering and Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science Games",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science/Business Administration",
                    "degree": "BS"
                },
                {
                    "name": "Data Science",
                    "degree": "BA"
                },
                {
                    "name": "Electrical and Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Industrial and Systems Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "USC Leonard Davis School of Gerontology",
            "source": {
                "label": "USC Catalogue 2026-2027, Programs by School",
                "url": "https://catalogue.usc.edu/content.php?catoid=22&navoid=9453"
            },
            "majors": [
                {
                    "name": "Human Development and Aging",
                    "degree": "BS"
                },
                {
                    "name": "Lifespan Health",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "USC Independent Health Professions at the Herman Ostrow School of Dentistry",
            "source": {
                "label": "USC Catalogue 2026-2027, Programs by School",
                "url": "https://catalogue.usc.edu/content.php?catoid=22&navoid=9453"
            },
            "majors": [
                {
                    "name": "Occupational Therapy",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "USC Gould School of Law",
            "source": {
                "label": "USC Catalogue 2026-2027, Programs by School",
                "url": "https://catalogue.usc.edu/content.php?catoid=22&navoid=9453"
            },
            "majors": [
                {
                    "name": "Law and Economics",
                    "degree": "BS"
                },
                {
                    "name": "Legal Studies",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Keck School of Medicine of USC",
            "source": {
                "label": "USC Catalogue 2026-2027, Programs by School",
                "url": "https://catalogue.usc.edu/content.php?catoid=22&navoid=9453"
            },
            "majors": [
                {
                    "name": "Global Health Studies",
                    "degree": "BS"
                },
                {
                    "name": "Health Promotion and Disease Prevention Studies",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "USC Thornton School of Music",
            "source": {
                "label": "USC Catalogue 2026-2027, Programs by School",
                "url": "https://catalogue.usc.edu/content.php?catoid=22&navoid=9453"
            },
            "majors": [
                {
                    "name": "Choral Music",
                    "degree": "BA",
                    "flag": "The USC application and a SlideRoom portfolio by December 1, then an audition and/or interview where your program requires one.",
                    "flagSource": "thornton"
                },
                {
                    "name": "Choral Music",
                    "degree": "BM",
                    "flag": "The USC application and a SlideRoom portfolio by December 1, then an audition and/or interview where your program requires one.",
                    "flagSource": "thornton"
                },
                {
                    "name": "Composition",
                    "degree": "BM",
                    "flag": "The USC application and a SlideRoom portfolio by December 1, then an audition and/or interview where your program requires one.",
                    "flagSource": "thornton"
                },
                {
                    "name": "Jazz Studies",
                    "degree": "BM",
                    "flag": "The USC application and a SlideRoom portfolio by December 1, then an audition and/or interview where your program requires one.",
                    "flagSource": "thornton"
                },
                {
                    "name": "Music",
                    "degree": "BA",
                    "flag": "The USC application and a SlideRoom portfolio by December 1, then an audition and/or interview where your program requires one.",
                    "flagSource": "thornton"
                },
                {
                    "name": "Music Industry",
                    "degree": "BM",
                    "flag": "The USC application and a SlideRoom portfolio by December 1, then an audition and/or interview where your program requires one.",
                    "flagSource": "thornton"
                },
                {
                    "name": "Music Industry",
                    "degree": "BS",
                    "flag": "The USC application and a SlideRoom portfolio by December 1, then an audition and/or interview where your program requires one.",
                    "flagSource": "thornton"
                },
                {
                    "name": "Music Production",
                    "degree": "BM",
                    "flag": "The USC application and a SlideRoom portfolio by December 1, then an audition and/or interview where your program requires one.",
                    "flagSource": "thornton"
                },
                {
                    "name": "Performance (Classical Guitar)",
                    "degree": "BM",
                    "flag": "The USC application and a SlideRoom portfolio by December 1, then an audition and/or interview where your program requires one.",
                    "flagSource": "thornton"
                },
                {
                    "name": "Performance (Flute), (Oboe), (Clarinet), (Bassoon), (Saxophone), (French Horn), (Trumpet), (Trombone), (Tuba) or (Percussion)",
                    "degree": "BM",
                    "flag": "The USC application and a SlideRoom portfolio by December 1, then an audition and/or interview where your program requires one.",
                    "flagSource": "thornton"
                },
                {
                    "name": "Performance (Organ)",
                    "degree": "BM",
                    "flag": "The USC application and a SlideRoom portfolio by December 1, then an audition and/or interview where your program requires one.",
                    "flagSource": "thornton"
                },
                {
                    "name": "Performance (Piano)",
                    "degree": "BM",
                    "flag": "The USC application and a SlideRoom portfolio by December 1, then an audition and/or interview where your program requires one.",
                    "flagSource": "thornton"
                },
                {
                    "name": "Performance (Popular Music)",
                    "degree": "BM",
                    "flag": "The USC application and a SlideRoom portfolio by December 1, then an audition and/or interview where your program requires one.",
                    "flagSource": "thornton"
                },
                {
                    "name": "Performance (Studio Guitar)",
                    "degree": "BM",
                    "flag": "The USC application and a SlideRoom portfolio by December 1, then an audition and/or interview where your program requires one.",
                    "flagSource": "thornton"
                },
                {
                    "name": "Performance (Violin), (Viola), (Violoncello), (Double Bass) or (Harp)",
                    "degree": "BM",
                    "flag": "The USC application and a SlideRoom portfolio by December 1, then an audition and/or interview where your program requires one.",
                    "flagSource": "thornton"
                },
                {
                    "name": "Performance (Vocal Arts)",
                    "degree": "BM",
                    "flag": "The USC application and a SlideRoom portfolio by December 1, then an audition and/or interview where your program requires one.",
                    "flagSource": "thornton"
                }
            ]
        },
        {
            "name": "USC Alfred E. Mann School of Pharmacy and Pharmaceutical Sciences",
            "source": {
                "label": "USC Catalogue 2026-2027, Programs by School",
                "url": "https://catalogue.usc.edu/content.php?catoid=22&navoid=9453"
            },
            "majors": [
                {
                    "name": "Biopharmaceutical Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Biopharmaceutical Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Pharmacology and Drug Development",
                    "degree": "BA"
                },
                {
                    "name": "Pharmacology and Drug Development",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "USC Price School of Public Policy",
            "source": {
                "label": "USC Catalogue 2026-2027, Programs by School",
                "url": "https://catalogue.usc.edu/content.php?catoid=22&navoid=9453"
            },
            "majors": [
                {
                    "name": "Public Policy",
                    "degree": "BS"
                },
                {
                    "name": "Real Estate Development",
                    "degree": "BS"
                },
                {
                    "name": "Urban Studies and Planning",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "USC Suzanne Dworak-Peck School of Social Work",
            "source": {
                "label": "USC Catalogue 2026-2027, Programs by School",
                "url": "https://catalogue.usc.edu/content.php?catoid=22&navoid=9453"
            },
            "majors": [
                {
                    "name": "Social Work",
                    "degree": "BSW"
                }
            ]
        }
    ]
};

export default majors;
